import { useRoute, useRouter, useState } from '#app'

export const PENDING_PRODUCT_NAVIGATION_STATE_KEY = 'lavmag:pending-product-navigation:path'

function isPrimaryUnmodifiedClick(event: MouseEvent) {
  return event.button === 0
    && !event.metaKey
    && !event.altKey
    && !event.ctrlKey
    && !event.shiftKey
}

function normalizeProductPath(to: string) {
  try {
    const url = new URL(to, 'https://lavmag.local')
    return url.origin === 'https://lavmag.local' ? url.pathname : ''
  } catch {
    return to.split(/[?#]/, 1)[0] ?? ''
  }
}

export function useInstantProductNavigation() {
  const route = useRoute()
  const router = useRouter()
  const pendingProductPath = useState<string | null>(
    PENDING_PRODUCT_NAVIGATION_STATE_KEY,
    () => null,
  )

  function clearPendingProductNavigation() {
    pendingProductPath.value = null
  }

  function beginProductNavigation(event: MouseEvent, to: string) {
    if (typeof window === 'undefined') return false
    if (!isPrimaryUnmodifiedClick(event)) return false

    const targetPath = normalizeProductPath(to)
    if (!targetPath.startsWith('/products/')) return false
    if (!route.path.startsWith('/products/')) return false
    if (targetPath === route.path) return false

    const navigationAlreadyStarted = event.defaultPrevented
    if (!navigationAlreadyStarted) {
      event.preventDefault()
    }

    pendingProductPath.value = targetPath
    window.scrollTo({ top: 0, behavior: 'instant' })

    if (!navigationAlreadyStarted) {
      void router.push(targetPath).catch(() => {
        clearPendingProductNavigation()
      })
    }

    return true
  }

  return {
    pendingProductPath,
    beginProductNavigation,
    clearPendingProductNavigation,
  }
}
